var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import LocalStorageService from "../../../services/localStorage";
import { STEP_PLANDETAILS } from "../../../const/catalog";
import React, { useEffect, useState } from "react";
import { typeAlert, } from "@affinitysystemsgroup/github-packages-affinity-components/dist";
import { PlanDetailsView } from "./planDetailView";
import { Steps } from "../../../enum/steps";
import { useGetPlansAllV2 } from "../../../fnx/plans/planGetAllV2";
import { GetPaymentMode } from "../../../fnx/paymentMode/getPaymentMode";
import { paymentModeClearData } from "../../../store/paymentModes/action";
import { useDispatch, useSelector } from "react-redux";
import { showErrorToast } from "../../../fnx/showError";
import { useTranslation } from "react-i18next";
import { plansClearData } from "../../../store/plans/actions";
import { quoteAddFields, quoteAddFieldsClearData, quoteOne, } from "../../../store/generateQuote/actions";
import { useLocation, useNavigate } from "react-router-dom";
import { usePatchQuote } from "../../../fnx/quotes/patchQuote";
import { formatToTwoDecimals } from "../../../utils/getPrice";
import { patchQuoteClearData } from "../../../store/updateQuote/actions";
import PagesHeader from "ah_utility/PagesHeader";
import { useGetSteps } from "../../../utils/getSteps";
import { AlertLoadingHeader } from "../../../components/alertLoadingComponent/alertLoading";
import showToast from "../../../services/toast";
import { findParamInLocalStorage } from "../../../utils/getAnyDataLocalStorge";
import { updateStepByPath } from "../../../utils/updateSteps";
import { insertIntoStepInformation } from "../../../utils/upsertStepInformation";
import { useGetInformationSteps } from "../../../utils/getInformationStep";
import { useCompleteStep } from "../../../utils/responseComplete";
import { getStepNavigation } from "../../../utils/nextBackStep";
import { updateStepInLocalStorage } from "../../../utils/updateStapeCustom";
var storageKey2 = "assurehub";
var storageKey3 = "afy-steps";
var lsLogin = new LocalStorageService(storageKey2);
var lsSteps = new LocalStorageService(storageKey3);
var STEP = STEP_PLANDETAILS;
export var PlanDetails = function () {
    var dispatch = useDispatch();
    var navigate = useNavigate();
    var pathname = useLocation().pathname;
    var t = useTranslation().t;
    var _a = React.useState(""), price = _a[0], setPrice = _a[1];
    var _b = React.useState(""), currencySymbol = _b[0], setCurrencySymbol = _b[1];
    var _c = React.useState([]), breadCrumbs = _c[0], setBreadCrumbs = _c[1];
    var _d = useState(false), trigger = _d[0], setTrigger = _d[1];
    var _e = useState(false), triggerPaymentMode = _e[0], setTriggerPaymentMode = _e[1];
    var _f = useState(false), triggerPatch = _f[0], setTriggerPatch = _f[1];
    var _g = useState(false), quoteResponse = _g[0], setQuoteResponse = _g[1];
    var _h = useState([]), listBenefit = _h[0], setListBenefit = _h[1];
    var _j = React.useState("Plan anual"), periodPlanName = _j[0], setPeriodPlanName = _j[1];
    var steps = useGetSteps();
    var _k = useState(false), enableNextBtn = _k[0], setEnableNextBtn = _k[1];
    var _l = useState(false), showAlert = _l[0], setShowAlert = _l[1];
    var autoClose = React.useState(10000)[0];
    var autoCloseActive = React.useState(false)[0];
    var msgDescription = React.useState("No es posible generar la cotización, por favor contacte con la aseguradora")[0];
    var _m = React.useState(""), paymentModeId = _m[0], setPaymentModeId = _m[1];
    var _o = React.useState(""), paymentModeName = _o[0], setPaymentModeName = _o[1];
    var _p = React.useState(), paymentMode = _p[0], setPaymentMode = _p[1];
    var _q = React.useState(), bodyPatchQuote = _q[0], setBodyPatchQuote = _q[1];
    var _r = React.useState([
        {
            id: "",
            name: "",
            value: "Anual",
        },
    ]), paymentModeList = _r[0], setPaymentModeList = _r[1];
    //Data Local Storage
    var Quote = React.useState(findParamInLocalStorage("Quote"))[0];
    var quoteId = Quote === null || Quote === void 0 ? void 0 : Quote.id;
    var clientId = React.useState(findParamInLocalStorage("clientId"))[0];
    var User = React.useState(findParamInLocalStorage("user"))[0];
    var userId = User === null || User === void 0 ? void 0 : User.id;
    var Plan = React.useState(findParamInLocalStorage("Plan"))[0];
    var valuePlanId = Plan === null || Plan === void 0 ? void 0 : Plan["0"].id;
    var projectId = React.useState(findParamInLocalStorage("projectId"))[0];
    var dataNavigation = React.useState(getStepNavigation(pathname))[0];
    var _s = useGetInformationSteps(pathname), instanceId = _s.instanceId, workFlowId = _s.workFlowId, currentStep = _s.currentStep, nextStep = _s.nextStep;
    //LLAMADO API COMPLETE
    var _t = useCompleteStep(), runComplete = _t.runComplete, loadingComplete = _t.loadingComplete, errorComplete = _t.errorComplete;
    var _u = React.useState({
        show: false,
        message: "",
        type: typeAlert.success,
    }), seeToast = _u[0], setSeeToast = _u[1];
    var _v = useSelector(function (state) { return ({
        responseQuoteAddFields: state.Quote.responseQuoteAddFields,
        errorQuoteAddFields: state.Quote.errorQuoteAddFields,
        loadingQuoteAddFields: state.Quote.loadingQuoteAddFields,
    }); }), responseQuoteAddFields = _v.responseQuoteAddFields, errorQuoteAddFields = _v.errorQuoteAddFields, loadingQuoteAddFields = _v.loadingQuoteAddFields;
    var _w = useSelector(function (state) { return ({
        responseOneQuote: state.Quote.responseOneQuote,
        errorOneQuote: state.Quote.errorOneQuote,
        loadingOneQuote: state.Quote.loadingOneQuote,
    }); }), responseOneQuote = _w.responseOneQuote, errorOneQuote = _w.errorOneQuote, loadingOneQuote = _w.loadingOneQuote;
    var _x = useGetPlansAllV2(trigger, valuePlanId, projectId || ""), responsePlans = _x.responsePlans, errorPlans = _x.errorPlans, loadingPlans = _x.loadingPlans;
    /*Llamada al PATCH QUOTE*/
    var _y = usePatchQuote(triggerPatch, bodyPatchQuote, quoteId), responsePatchQuote = _y.responsePatchQuote, errorPatchQuote = _y.errorPatchQuote, loadingPatchQuote = _y.loadingPatchQuote;
    var _z = GetPaymentMode(triggerPaymentMode, projectId || ""), responsePaymentMode = _z.responsePaymentMode, errorPaymentMode = _z.errorPaymentMode, loadingPaymentMode = _z.loadingPaymentMode;
    var callQuoteOne = function (quoteId) {
        dispatch(quoteOne({
            id: quoteId,
            fullBody: true,
        }));
    };
    useEffect(function () {
        setTrigger(true);
        setTriggerPaymentMode(true);
    }, []);
    useEffect(function () {
        if (errorQuoteAddFields) {
            showErrorToast(errorQuoteAddFields, setSeeToast, t);
        }
    }, [errorQuoteAddFields]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
            dispatch(plansClearData());
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
            dispatch(paymentModeClearData());
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (responseQuoteAddFields && responseQuoteAddFields.data) {
            lsSteps.setStepStored({
                id: lsSteps.getStepStored().steps[Steps.plan].id,
                name: lsSteps.getStepStored().steps[Steps.plan].name,
                step: Steps.plan,
                completed: false,
                campaign: lsSteps.getStepStored().steps[Steps.plan].campaign,
                campaignSelected: lsSteps.getStepStored().steps[Steps.plan].campaignSelected,
                coverType: lsSteps.getStepStored().steps[Steps.plan].coverType,
                paymentModeSelected: paymentMode,
                price: {
                    amount: responseQuoteAddFields.data.lastPrice.amount,
                    currency: responseQuoteAddFields.data.lastPrice.currencySymbol,
                },
            });
            if (!quoteResponse) {
                if (quoteId !== undefined) {
                    callQuoteOne(quoteId);
                    setQuoteResponse(true);
                }
            }
            dispatch(quoteAddFieldsClearData());
        }
    }, [responseQuoteAddFields]);
    useEffect(function () {
        // if (responsePaymentMode?.length > 0) {
        if (quoteId !== undefined) {
            callQuoteOne(quoteId);
        }
        // }
    }, [responsePaymentMode]);
    useEffect(function () {
        if (errorPatchQuote) {
            setTriggerPatch(false);
            showErrorToast(errorPatchQuote, setSeeToast, t);
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        var paymentModeSelected = paymentModeList.find(function (item) { return item.value === "Anual"; });
        if (paymentModeSelected) {
            setPaymentModeId(paymentModeSelected.id || "");
        }
    }, [paymentModeList]);
    useEffect(function () {
        var _a, _b, _c;
        if ((responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.length) > 0) {
            var paymentRecurrence = responsePaymentMode === null || responsePaymentMode === void 0 ? void 0 : responsePaymentMode.map(function (item) {
                var _a, _b, _c;
                return ({
                    id: (_a = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _a === void 0 ? void 0 : _a.id,
                    name: (_b = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _b === void 0 ? void 0 : _b.description,
                    value: (_c = item === null || item === void 0 ? void 0 : item.catalogPaymentMode) === null || _c === void 0 ? void 0 : _c.code,
                });
            });
            setPaymentModeList(paymentRecurrence);
            var payment = {
                id: (_a = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _a === void 0 ? void 0 : _a.id,
                description: (_b = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _b === void 0 ? void 0 : _b.name,
                code: (_c = paymentRecurrence === null || paymentRecurrence === void 0 ? void 0 : paymentRecurrence[0]) === null || _c === void 0 ? void 0 : _c.value,
            };
            setPaymentMode(payment);
            setPaymentModeId(payment.id);
            setPaymentModeName(payment.code);
            dispatch(paymentModeClearData());
        }
    }, [responsePaymentMode]);
    useEffect(function () {
        var _a;
        if (responseOneQuote && (responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data)) {
            var quotePatch = {
                planId: responseOneQuote.data.planId.id,
                coverTypeId: (_a = responseOneQuote.data.planId.coverTypes) === null || _a === void 0 ? void 0 : _a[0].id,
                campaignId: responseOneQuote.data.campaignId.id,
                catalogStatusQuote: responseOneQuote.data.catalogStatusQuote.id,
                branchId: responseOneQuote.data.branch,
                userId: userId || "",
                catalogPaymentMode: paymentModeId,
            };
            if (!quoteResponse) {
                if (paymentModeId !== "") {
                    setBodyPatchQuote(quotePatch);
                    setTriggerPatch(true);
                }
            }
            if (quoteResponse) {
                var numericValue = parseFloat(responseOneQuote.data.lastPrice.amount
                    ? responseOneQuote.data.lastPrice.amount
                    : "0.00");
                if (paymentModeName === "MON") {
                    //const fNumber: number = numericValue / 12;
                    var fNumber = numericValue;
                    setPrice(responseOneQuote.data.lastPrice.amount
                        ? formatToTwoDecimals(fNumber.toString())
                        : "0.00");
                }
                else {
                    setPrice(responseOneQuote.data.lastPrice.amount
                        ? formatToTwoDecimals(responseOneQuote.data.lastPrice.amount)
                        : "0.00");
                }
                setCurrencySymbol(responseOneQuote.data.lastPrice.currencySymbol);
                setQuoteResponse(false);
                if (responseOneQuote.data.lastPrice.amount === "0.00") {
                    setShowAlert(true);
                    setEnableNextBtn(false);
                }
                else {
                    setShowAlert(false);
                }
            }
            //dispatch(quoteOneClearData());
        }
    }, [responseOneQuote, responsePaymentMode]);
    /*Valida respuesta cuando ya se actualizo el registro*/
    useEffect(function () {
        if (responsePatchQuote) {
            setTriggerPatch(false);
            /*Llama al api para recuperar el precio*/
            callQuoteAddFields();
            dispatch(patchQuoteClearData());
        }
    }, [responsePatchQuote]);
    /*Valida respuesta del getAll y mapea objetos*/
    useEffect(function () {
        var _a;
        if (responsePlans && responsePlans.length > 0) {
            var list = responsePlans === null || responsePlans === void 0 ? void 0 : responsePlans.map(function (item) { return ({
                benefits: item.benefits,
            }); });
            var listB = list[0].benefits;
            if (listB) {
                setListBenefit(listB);
            }
            else {
                setListBenefit([]);
            }
            setTrigger(false);
        }
        else if (responsePlans && ((_a = responsePlans.data) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            setTrigger(false);
            setListBenefit([]);
        }
    }, [responsePlans]);
    var onApplySelected = function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        switch (item.valueSelected.value) {
            case "MON":
                setPeriodPlanName("Plan mensual");
                break;
            case "ANU":
                setPeriodPlanName("Plan anual");
                break;
            default:
                setPeriodPlanName("Plan anual");
                break;
        }
        setPaymentModeId((_a = item === null || item === void 0 ? void 0 : item.valueSelected) === null || _a === void 0 ? void 0 : _a.id);
        setPaymentModeName(item.valueSelected.value);
        var payment = {
            id: item.valueSelected.id,
            description: item.valueSelected.name,
            code: item.valueSelected.value,
        };
        setPaymentMode(payment);
        var quotePatch = {
            planId: (_c = (_b = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _b === void 0 ? void 0 : _b.planId) === null || _c === void 0 ? void 0 : _c.id,
            coverTypeId: (_f = (_e = (_d = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _d === void 0 ? void 0 : _d.planId) === null || _e === void 0 ? void 0 : _e.coverTypes) === null || _f === void 0 ? void 0 : _f[0].id,
            campaignId: (_h = (_g = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _g === void 0 ? void 0 : _g.campaignId) === null || _h === void 0 ? void 0 : _h.id,
            catalogStatusQuote: (_k = (_j = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _j === void 0 ? void 0 : _j.catalogStatusQuote) === null || _k === void 0 ? void 0 : _k.id,
            branchId: (_l = responseOneQuote === null || responseOneQuote === void 0 ? void 0 : responseOneQuote.data) === null || _l === void 0 ? void 0 : _l.branch,
            userId: userId || "",
            catalogPaymentMode: payment === null || payment === void 0 ? void 0 : payment.id,
        };
        setBodyPatchQuote(quotePatch);
        setTriggerPatch(true);
    };
    var onClickNext = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, prevStep, currentStep_1, nextStep_1, sessionData, err_1;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    callQuoteAddFields();
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, runComplete({
                            workFlowId: workFlowId,
                            instanceId: instanceId,
                            currentStep: currentStep,
                            nextStep: nextStep,
                        })];
                case 2:
                    res = _f.sent();
                    if (res) {
                        updateStepByPath(pathname);
                        prevStep = (_a = res.upcomingFormStep) === null || _a === void 0 ? void 0 : _a.prevSteps[0];
                        currentStep_1 = (_b = res.upcomingFormStep) === null || _b === void 0 ? void 0 : _b.id;
                        nextStep_1 = (_c = res.upcomingFormStep) === null || _c === void 0 ? void 0 : _c.nextSteps[0];
                        insertIntoStepInformation({
                            stepKey: pathname,
                            data: {
                                currentStep: currentStep_1,
                                nextStep: nextStep_1,
                                prevStep: prevStep,
                            },
                        });
                        sessionData = ((_d = res.sessionData) === null || _d === void 0 ? void 0 : _d.apiResponses) || [];
                        if (sessionData.length > 0) {
                            updateStepInLocalStorage(pathname, sessionData);
                        }
                        navigate("".concat(dataNavigation === null || dataNavigation === void 0 ? void 0 : dataNavigation.next));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _f.sent();
                    setSeeToast({
                        show: true,
                        message: (_e = err_1 === null || err_1 === void 0 ? void 0 : err_1.message) !== null && _e !== void 0 ? _e : "Ocurrió un error al completar el paso.",
                        type: typeAlert.error,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var callQuoteAddFields = function () {
        var body = {
            value: paymentModeId,
        };
        dispatch(quoteAddFields({ id: quoteId, key: "paymentFrequency", body: body }));
    };
    return (_jsxs(_Fragment, { children: [_jsx(PagesHeader, { titlePage: "Detalle del plan", hideStep: false, steps: steps }), _jsx(AlertLoadingHeader, { loading: loadingPlans ||
                    loadingOneQuote ||
                    loadingQuoteAddFields ||
                    loadingPatchQuote ||
                    loadingComplete, seeToast: seeToast, showToast: showToast, setSeeToast: setSeeToast, titleLoading: "Cargando plan..." }), _jsx(PlanDetailsView, { apap: true, title: "Modalidad de Plan", btnLblNext: "Siguiente", currencyLbl: currencySymbol, defaultSelect: paymentMode === null || paymentMode === void 0 ? void 0 : paymentMode.code, periodPlan: periodPlanName, subtitleBenefit: "Coberturas", subtitleLimit: "Límites", titleDetail: "Detalle del plan", price: price, steps: steps, breadCrumbs: breadCrumbs, onClickNext: onClickNext, listBen: listBenefit, applySelect: onApplySelected, paymentModeList: paymentModeList, msgDescription: msgDescription, showAlert: showAlert, autoClose: autoClose, autoCloseActive: autoCloseActive, setShowAlert: setShowAlert, 
                // disabledNextButton={false} // Para produccion  utilizar props.enableNextBtn
                // enableNextBtn={false}
                enableNextBtn: parseInt(price) <= 0 })] }));
};
